import { UserGlobalRecord } from '@vms/vmspro3-core/dist/types'

import Server from '../server/VMSProServerAdapter'

export async function getCurrentUser(userId: string) {
  const { authUser } = (await Server.fetchInitialState(userId)) as { authUser: UserGlobalRecord }
  return authUser
}
